export default __webpack_public_path__ + "static/media/economicHome.19f7b4ac.jpg";